export const MAIN_NAVIGATION = [
    {
        path: '/documentations/get-started',
        label: 'Get Started',
        icon: 'pi pi-fw pi-home',
    },
    {
        path: '/documentations/api-specs',
        label: 'API Specs',
        icon: 'pi pi-fw pi-share-alt',
    },
    {
        path: '/documentations/user-guide',
        label: 'User Guide',
        icon: 'pi pi-fw pi-id-card',
    },
]

export const PROJECTS_NAVIGATION = [
    {
        path: '/',
        label: 'Dashboard',
        icon: 'pi pi-fw pi-chart-bar',
        showProjectsSelect: true
    },
    {
        path: '/translations',
        label: 'Translations',
        icon: 'pi pi-fw pi-globe',
        showProjectsSelect: true,
    },
    {
        path: '/projects',
        label: 'Projects',
        icon: 'pi pi-fw pi-address-book',
        showProjectsSelect: false
    },
]
